import { schema } from 'normalizr';

const partFileSchema = new schema.Entity(
  'partFiles',
  {},
  {
    idAttribute: 'uuid',
  },
);

const viewerPartSchema = new schema.Entity('viewerParts', {
  partFile: partFileSchema,
});

const viewerBodySchema = new schema.Entity(
  'viewerBodies',
  {},
  {
    idAttribute: 'viewerId',
  },
);

viewerBodySchema.define({
  children: [viewerBodySchema],
  viewerPart: viewerPartSchema,
});

export { partFileSchema, viewerBodySchema, viewerPartSchema };
